<template>
  <v-app>
    <v-main style="overflow:hidden;">
      <navbar class="navbarcita" @muestraMenuLateralx="drawer = !drawer" />
      <router-view></router-view>
    </v-main>
    <v-navigation-drawer elevation="11" v-model="drawer" fixed temporary>
      <v-list-item>
        <v-list-item-content>
          <v-menu v-if="$store.state.sesion.logedInUserInfo.id">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" rounded color="deep-purple" dark
                ><v-icon medium class="mr-2"> mdi-account </v-icon>{{ logedInUserInfo.nombre }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="cerrarSesion()">
                <v-list-item-title>Cerrar sesión</v-list-item-title>
              </v-list-item>
              <v-list-item @click="cambiarDatos()">
                <v-list-item-title>Cambiar contraseña</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="(menu, index) in logedInUserInfo.menus" :key="index">
        <v-list-item-content>
          <v-btn class="mr-2" :to="menu.View" rounded color="blue darken-1" dark text>{{
            menu.texto
          }}</v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
    <ModalCambioContrasena
      v-if="mostrarPreferenciasUsuario"
      :mostrarPreferenciasUsuario="mostrarPreferenciasUsuario"
      @ocultaModalCambiodeContrasena="ocultaModalCambiodeContrasena"
    />
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import { mapState, mapActions } from "vuex";
import ModalCambioContrasena from "@/components/modales/ModalCambioContrasena.vue";

export default {
  name: "App",
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo,
      logedInUserTokens: state => state.sesion.logedInUserTokens
    })
  },
  components: {
    Navbar,
    ModalCambioContrasena
  },
  methods: {
    ...mapActions("sesion", ["logOut"]),
    cambiarDatos() {
      this.mostrarPreferenciasUsuario = true;
    },
    ocultaModalCambiodeContrasena() {
      this.mostrarPreferenciasUsuario = false;
    },
    async cerrarSesion() {
      const objetoCierreSesion = new Object();
      objetoCierreSesion.Usuario = this.logedInUserInfo.usuario;
      objetoCierreSesion.RefreshTkn = this.logedInUserTokens.refreshToken;
      const res = await this.logOut(objetoCierreSesion);
      if (res) {
        this.$router.replace("login");
      } else {
      }
    }
  },
  data: () => ({
    drawer: false,
    mostrarPreferenciasUsuario: false
  })
};
</script>

<style lang="css">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;600&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@900&display=swap');

@media print {
  .navbarcita {
    display: none;
  }
}
</style>
